/* HATS THAT GO HARD — Theme JS v2.0 */
(function() {
  'use strict';

  // Mobile Menu
  var mobileMenuBtn = document.getElementById('mobile-menu-btn');
  var mobileNav = document.getElementById('mobile-nav');
  var mobileNavClose = document.getElementById('mobile-nav-close');

  if (mobileMenuBtn && mobileNav) {
    mobileMenuBtn.addEventListener('click', function() {
      mobileNav.classList.add('active');
      mobileNav.setAttribute('aria-hidden', 'false');
      mobileMenuBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });
    if (mobileNavClose) {
      mobileNavClose.addEventListener('click', closeMobileNav);
    }
    mobileNav.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', closeMobileNav);
    });
  }

  function closeMobileNav() {
    mobileNav.classList.remove('active');
    mobileNav.setAttribute('aria-hidden', 'true');
    mobileMenuBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  // Cart Drawer
  var cartDrawer = document.getElementById('cart-drawer');
  var openCartBtns = document.querySelectorAll('[data-open-cart]');
  var closeCartBtns = document.querySelectorAll('[data-close-cart]');

  if (cartDrawer) {
    openCartBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        cartDrawer.classList.add('active');
        cartDrawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });
    closeCartBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        cartDrawer.classList.remove('active');
        cartDrawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    });
  }

  // Product Variant Buttons
  var variantBtns = document.querySelectorAll('.variant-btn');
  variantBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var optionName = this.getAttribute('data-option');
      var siblings = document.querySelectorAll('.variant-btn[data-option="' + optionName + '"]');
      siblings.forEach(function(s) { s.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  // Product Image Thumbnails
  var thumbs = document.querySelectorAll('.product-page__thumb');
  var mainImage = document.getElementById('product-main-image');
  if (mainImage && thumbs.length > 0) {
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');
        var newSrc = this.getAttribute('data-src');
        if (newSrc) { mainImage.src = newSrc; }
      });
    });
  }

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

})();
